<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b><a id="page_x"></a><a id="page_1">PART I</a></b></p><a id="page_1">
<p class="h1a">The Attic</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?a3abb994